var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2048_5732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2048_5732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 16.6667C4.30547 16.6667 3.7152 16.4237 3.22909 15.9375C2.74297 15.4514 2.49992 14.8612 2.49992 14.1667H0.833252V5.00004C0.833252 4.54171 0.996446 4.14935 1.32284 3.82296C1.64922 3.49657 2.04159 3.33337 2.49992 3.33337H14.1666V6.66671H16.6666L19.1666 10V14.1667H17.4999C17.4999 14.8612 17.2569 15.4514 16.7708 15.9375C16.2846 16.4237 15.6944 16.6667 14.9999 16.6667C14.3055 16.6667 13.7152 16.4237 13.2291 15.9375C12.743 15.4514 12.4999 14.8612 12.4999 14.1667H7.49992C7.49992 14.8612 7.25686 15.4514 6.77075 15.9375C6.28464 16.4237 5.69436 16.6667 4.99992 16.6667ZM4.99992 15C5.23603 15 5.43395 14.9202 5.59367 14.7605C5.75339 14.6007 5.83325 14.4028 5.83325 14.1667C5.83325 13.9306 5.75339 13.7327 5.59367 13.573C5.43395 13.4132 5.23603 13.3334 4.99992 13.3334C4.76381 13.3334 4.56589 13.4132 4.40617 13.573C4.24645 13.7327 4.16659 13.9306 4.16659 14.1667C4.16659 14.4028 4.24645 14.6007 4.40617 14.7605C4.56589 14.9202 4.76381 15 4.99992 15ZM14.9999 15C15.236 15 15.4339 14.9202 15.5937 14.7605C15.7534 14.6007 15.8333 14.4028 15.8333 14.1667C15.8333 13.9306 15.7534 13.7327 15.5937 13.573C15.4339 13.4132 15.236 13.3334 14.9999 13.3334C14.7638 13.3334 14.5659 13.4132 14.4062 13.573C14.2464 13.7327 14.1666 13.9306 14.1666 14.1667C14.1666 14.4028 14.2464 14.6007 14.4062 14.7605C14.5659 14.9202 14.7638 15 14.9999 15ZM14.1666 10.8334H17.7083L15.8333 8.33337H14.1666V10.8334Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalShipping);
export default __webpack_public_path__ + "static/media/local_shipping.acf842e36b08e0f92829a82b34f8f53e.svg";
export { ForwardRef as ReactComponent };